import { percentageOfResponses } from "./shared";

export function keyDriversTooltip(item) {
  if (item.scale_points == 5) {
    return `
      <div class="flex p-2 text-sm bg-white text-left shadow-lg rounded-lg border">
        <div class="w-64 pr-5 text-xs bg-white text-left border-r border-gray-100">
          <div class="mb-1.5 text-gray-400">
            Survey item
          </div>
          <div class="mt-1 text-gray-700">
            ${window.scrubHtml(item.prompt)}
          </div>
          <div class="mt-5 text-gray-400">
            Scoring method
          </div>
          <div class="mt-1 text-gray-700">
            Percent favorable
          </div>
        </div>
        <div class="w-64 ml-5">
          <div class="text-xs text-gray-500 mb-2.5">
            Distribution
          </div>
          <div class="h-5 flex items-center justify-between">
            <div class="w-4/12 text-right pr-2.5 text-xs text-gray-600">Never</div>
            <div class="flex items-center grow w-8/12 rounded-full overflow-hidden">
              <div class="h-1 py-px bg-gray-400 rounded-full" style="width: ${percentageOfResponses(
                item,
                "one_count",
                "count",
              )}"></div>
              <div class="w-8 ml-2 text-gray-500 text-3xs">${percentageOfResponses(
                item,
                "one_count",
                "count",
              )}</div>
            </div>
          </div>
          <div class="h-5 flex items-center justify-between">
            <div class="w-4/12 text-right pr-2.5 text-xs text-gray-600">Rarely</div>
            <div class="flex items-center grow w-8/12 rounded-full overflow-hidden">
              <div class="h-1 py-px bg-gray-400 rounded-full" style="width: ${percentageOfResponses(
                item,
                "two_count",
                "count",
              )}"></div>
              <div class="w-8 ml-2 text-gray-500 text-3xs">${percentageOfResponses(
                item,
                "two_count",
                "count",
              )}</div>
            </div>
          </div>
          <div class="h-5 flex items-center justify-between">
            <div class="w-4/12 text-right pr-2.5 text-xs text-gray-600">Sometimes</div>
            <div class="flex items-center grow w-8/12 rounded-full overflow-hidden">
              <div class="h-1 py-px bg-gray-400 rounded-full" style="width: ${percentageOfResponses(
                item,
                "three_count",
                "count",
              )}"></div>
              <div class="w-8 ml-2 text-gray-500 text-3xs">${percentageOfResponses(
                item,
                "three_count",
                "count",
              )}</div>
            </div>
          </div>
          <div class="h-5 flex items-center justify-between">
            <div class="w-4/12 text-right pr-2.5 text-xs text-gray-600">Very often</div>
            <div class="flex items-center grow w-8/12 rounded-full overflow-hidden">
              <div class="h-1 py-px bg-gray-400 rounded-full" style="width: ${percentageOfResponses(
                item,
                "four_count",
                "count",
              )}"></div>
              <div class="w-8 ml-2 text-gray-500 text-3xs">${percentageOfResponses(
                item,
                "four_count",
                "count",
              )}</div>
            </div>
          </div>
          <div class="h-5 flex items-center justify-between">
            <div class="w-4/12 text-right pr-2.5 text-xs text-gray-600">Always</div>
            <div class="flex items-center grow w-8/12 rounded-full overflow-hidden">
              <div class="h-1 py-px bg-gray-400 rounded-full" style="width: ${percentageOfResponses(
                item,
                "five_count",
                "count",
              )}"></div>
              <div class="w-8 ml-2 text-gray-500 text-3xs">${percentageOfResponses(
                item,
                "five_count",
                "count",
              )}</div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  return `
    <div class="flex p-2 text-sm bg-white text-left shadow-lg rounded-lg border">
      <div class="w-64 pr-5 text-xs bg-white text-left border-r border-gray-100">
        <div class="mb-1.5 text-gray-400">
          Survey item
        </div>
        <div class="mt-1 text-gray-700">
          Please rate the following area of your work: ${window.scrubHtml(item.prompt)}
        </div>
        <div class="mt-5 text-gray-400">
          Scoring method
        </div>
        <div class="mt-1 text-gray-700">
          Percent favorable
        </div>
      </div>
      <div class="w-64 ml-5">
        <div class="text-xs text-gray-500 mb-2.5">
          Distribution
        </div>
        <div class="h-5 flex items-center justify-between">
          <div class="w-4/12 text-right pr-2.5 text-xs text-gray-600">Bad</div>
          <div class="flex items-center grow w-8/12 rounded-full overflow-hidden">
            <div class="h-1 py-px bg-gray-400 rounded-full" style="width: ${percentageOfResponses(
              item,
              "one_count",
              "count",
            )}"></div>
            <div class="w-8 ml-2 text-gray-500 text-3xs">${percentageOfResponses(
              item,
              "one_count",
              "count",
            )}</div>
          </div>
        </div>
        <div class="h-5 flex items-center justify-between">
          <div class="w-4/12 text-right pr-2.5 text-xs text-gray-600">So-so</div>
          <div class="flex items-center grow w-8/12 rounded-full overflow-hidden">
            <div class="h-1 py-px bg-gray-400 rounded-full" style="width: ${percentageOfResponses(
              item,
              "two_count",
              "count",
            )}"></div>
            <div class="w-8 ml-2 text-gray-500 text-3xs">${percentageOfResponses(
              item,
              "two_count",
              "count",
            )}</div>
          </div>
        </div>
        <div class="h-5 flex items-center justify-between">
          <div class="w-4/12 text-right pr-2.5 text-xs text-gray-600">Good</div>
          <div class="flex items-center grow w-8/12 rounded-full overflow-hidden">
            <div class="h-1 py-px bg-gray-400 rounded-full" style="width: ${percentageOfResponses(
              item,
              "three_count",
              "count",
            )}"></div>
            <div class="w-8 ml-2 text-gray-500 text-3xs">${percentageOfResponses(
              item,
              "three_count",
              "count",
            )}</div>
          </div>
        </div>
      </div>
    </div>
  `;
}
